import { FormattedMessage } from 'react-intl'

import { H3 } from 'components/Typography'
import { myAccountMessages } from './messages'
import { MyAccountPageWrap, StyledAccountContainer } from './styles'
import MyAccountForm from './MyAccountForm'
import ChangePassword from './ChangePassword'
import TwoFactor from './TwoFactor'

function MyAccountPage() {
  return (
    <MyAccountPageWrap>
      <H3>{<FormattedMessage {...myAccountMessages.myAccount} />}</H3>
      <StyledAccountContainer>
        <MyAccountForm />
        <ChangePassword />
        <TwoFactor />
      </StyledAccountContainer>
    </MyAccountPageWrap>
  )
}

export default MyAccountPage
